import { getMeasurementInUnit } from '@utils';

export const stateKeys = {
  width: 'Width',
  height: 'Height',
  length: 'Length',
  _userUnit: '_userUnit',
  'Room Name': 'Room Name',
};

export const stateTypes = {
  width: Number,
  height: Number,
  length: Number,
  'Room Name': String,
};

export const loadStateFromURL = ({ stateKey, setter, value, defaultValue }) => {
  if (Object.keys(stateKeys).includes(stateKey)) {
    let params = new URLSearchParams(window.location.search);
    let valueToLoad = params.get(stateKeys[stateKey]);
    if (valueToLoad) {
      let loadedUnit = params.get('_userUnit');
      switch (stateTypes[stateKey]) {
        case Number:
          let valueInUnit = getMeasurementInUnit(valueToLoad, 'metric', loadedUnit);
          if (valueInUnit) {
            setter(Math.round(valueInUnit * 100) / 100);
          }
          break;

        default:
          setter(valueToLoad);
          break;
      }
    }
  } else {
    if (!value) {
      setter(defaultValue);
    }
  }
};
